"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ON_MATCH_DELAY = 500;

var ShortcutManager = /*#__PURE__*/function () {
  function ShortcutManager() {
    var _this = this;

    _classCallCheck(this, ShortcutManager);

    this.keysPressed = [];
    this.shortcuts = [];
    this.shortcutsMatched = [];
    this.timer = void 0;

    this.handleKeyDown = function (event) {
      var key = event.key;

      _this.keysPressed.push(key);

      _this.updateMatchingShortcuts(event);

      switch (_this.shortcutsMatched.length) {
        case 0:
          _this.resetKeys();

          break;

        case 1:
          _this.callMatchedShortcut(event);

          break;

        default:
          _this.timer = window.setTimeout(function () {
            _this.callMatchedShortcut(event);
          }, ON_MATCH_DELAY);
      }
    };
  }

  _createClass(ShortcutManager, [{
    key: "setup",
    value: function setup() {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "subscribe",
    value: function subscribe(data) {
      var shortcuts = this.shortcuts;
      shortcuts.push(data);
      return {
        unsubscribe: function unsubscribe() {
          var unsubscribeIndex = shortcuts.findIndex(function (shortcut) {
            return shortcut === data;
          });
          shortcuts.splice(unsubscribeIndex, 1);
        }
      };
    }
  }, {
    key: "resetKeys",
    value: function resetKeys() {
      this.keysPressed = [];
      this.shortcutsMatched = [];
    }
  }, {
    key: "allModifiersAreHeld",
    value: function allModifiersAreHeld(heldKeys, event) {
      function hasKeyGroups(groups) {
        return groups.every(function (key) {
          return Array.isArray(key);
        });
      }

      function keyGroupIsHeld(keyGroup) {
        return keyGroup.every(function (key) {
          return event.getModifierState && event.getModifierState(key);
        });
      }

      return hasKeyGroups(heldKeys) ? heldKeys.some(keyGroupIsHeld) : keyGroupIsHeld(heldKeys);
    }
  }, {
    key: "updateMatchingShortcuts",
    value: function updateMatchingShortcuts(event) {
      var _this2 = this;

      var shortcuts = this.shortcutsMatched.length > 0 ? this.shortcutsMatched : this.shortcuts;
      this.shortcutsMatched = shortcuts.filter(function (_ref) {
        var ordered = _ref.ordered,
            held = _ref.held,
            node = _ref.node,
            ignoreInput = _ref.ignoreInput;

        if (isFocusedInput() && !ignoreInput) {
          return false;
        }

        if (held && !_this2.allModifiersAreHeld(held, event)) {
          return false;
        }

        var partiallyMatching = arraysMatch(_this2.keysPressed, ordered.slice(0, _this2.keysPressed.length));

        if (node) {
          var onFocusedNode = document.activeElement === node;
          return partiallyMatching && onFocusedNode;
        }

        return partiallyMatching;
      });
    }
  }, {
    key: "callMatchedShortcut",
    value: function callMatchedShortcut(event) {
      var _this3 = this;

      var longestMatchingShortcut = this.shortcutsMatched.find(function (_ref2) {
        var ordered = _ref2.ordered;
        return arraysMatch(ordered, _this3.keysPressed);
      });

      if (!longestMatchingShortcut) {
        return;
      }

      if (!longestMatchingShortcut.allowDefault) {
        event.preventDefault();
      }

      longestMatchingShortcut.onMatch({
        ordered: longestMatchingShortcut.ordered,
        held: longestMatchingShortcut.held
      });
      clearTimeout(this.timer);
      this.resetKeys();
    }
  }]);

  return ShortcutManager;
}();

exports["default"] = ShortcutManager;

function isFocusedInput() {
  var target = document.activeElement;

  if (target == null || target.tagName == null) {
    return false;
  }

  return target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.hasAttribute('contenteditable');
}

function arraysMatch(first, second) {
  if (first.length !== second.length) {
    return false;
  }

  return first.every(function (value, index) {
    return second[index] === value;
  });
}